import {Menu, Popover, Transition} from "@headlessui/react";
import {UserCircleIcon} from "@heroicons/react/outline";
import {Fragment} from "react";
import {classNames, isAdmin, isSalesman} from "../../lib";
import LogoutButton from "./LogoutButton";
import SecondOperation from "./SecondOperation";

function formatUserDetails(user) {
  return {
    name: `${user.firstname} ${user.lastname}`,
    email: user.email,
  };
}

function getNavigation(role) {
  return isAdmin(role)
    ? [
      {name: "Admin", href: "/admin/angebote"},
      {name: "Pflanzer wechseln", href: "/pflanzer"},
      {name: "Konto", href: "/konto"},
    ]
    : isSalesman(role)
      ? [
        {name: "Pflanzer wechseln", href: "/pflanzer"},
        {name: "Konto", href: "/konto"},
      ]
      : [{name: "Konto", href: "/konto"}];
}

export function ProfileMenu({auth, secondGrower, onLogoutClick}) {
  const user = formatUserDetails(auth.user)

  return (
    <div className="hidden lg:flex lg:items-center lg:justify-end xl:col-span-4">
      <p>{user.name}</p>

      <Menu as="div" className="flex-shrink-0 relative ml-5">
        {({open}) => (
          <>
            <div>
              <Menu.Button className="bg-white rounded-full flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                <span className="sr-only">Open user menu</span>
                <UserCircleIcon
                  className="h-6 w-6 hover:text-primary"
                  aria-hidden="true"
                />
              </Menu.Button>
            </div>
            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                static
                className="origin-top-right absolute z-10 right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none"
              >
                {getNavigation(auth.user.role).map((item) => (
                  <Menu.Item key={item.name}>
                    {({active}) => (
                      <a
                        href={item.href}
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "block py-2 px-4 text-sm text-gray-700"
                        )}
                      >
                        {item.name}
                      </a>
                    )}
                  </Menu.Item>
                ))}
                <SecondOperation auth={auth} secondGrower={secondGrower} mobile={false}/>
                <LogoutButton classList="block py-2 px-4 text-sm text-gray-700"/>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  )
}

export function MobileProfileMenu({auth, secondGrower, navigation}) {
  const user = formatUserDetails(auth.user)

  return (
    <Popover.Panel as="nav" className="lg:hidden" aria-label="Global">
      <div className="z-10 max-w-3xl mx-auto px-2 pt-2 pb-3 space-y-1 sm:px-4">
        {navigation.map((item) => (
          <a
            key={item.name}
            href={item.href}
            aria-current={item.current ? "page" : undefined}
            className={classNames(
              item.current
                ? "bg-gray-100 text-gray-900"
                : "hover:bg-gray-50",
              "block rounded-md py-2 px-3 text-base font-medium"
            )}
          >
            {item.name}
          </a>
        ))}
      </div>
      <div className="border-t border-gray-200 pt-4 pb-3">
        <div className="max-w-3xl mx-auto px-4 flex items-center sm:px-6">
          <div className="flex-shrink-0">
            <UserCircleIcon className="h-6 w-6" aria-hidden="true"/>
          </div>
          <div className="ml-3">
            <div className="text-base font-medium text-gray-800">
              {user.name}
            </div>
            <div className="text-sm font-medium text-gray-500">
              {user.email}
            </div>
          </div>
        </div>
        <div className="mt-3 max-w-3xl mx-auto px-2 space-y-1 sm:px-4">
          {getNavigation(auth.user.role).map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
            >
              {item.name}
            </a>
          ))}
          <SecondOperation auth={auth} secondGrower={secondGrower} mobile={true}/>
          <LogoutButton classList="block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"/>
        </div>
      </div>
    </Popover.Panel>
  )
}
